/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-useless-fragment */
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';

import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import {
  MdDelete,
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdPhoto,
} from 'react-icons/md';

import GlobalContext from '../../../context/GlobalContext';

import api, { authHeader } from '../../../services/API/apiConfig';
import {
  DeleteButtonStyled,
  MainImageStyled,
  MobileSectionStyled,
  RootStyled,
  SectionStyled,
  ThumbStyled,
} from './ImageSlide.styles';

export function ImageSlider(props) {
  const { slides, setSlides, index } = props;

  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);

  const user = JSON.parse(localStorage.getItem('user'));
  const baseURL = process.env.REACT_APP_API;
  const protocol = subdomain.endsWith('-st') ? 'http' : 'https';

  const [current, setCurrent] = useState(index);
  const { length } = slides;

  function nextSlide() {
    setCurrent(current === length - 1 ? 0 : current + 1);
  }
  function previousSlide() {
    setCurrent(current === 0 ? length - 1 : current - 1);
  }

  if (!Array.isArray(slides) || slides.length <= 0) {
    return null;
  }

  async function deletePhoto(photoIndex) {
    if (current + 1 === slides.length) {
      setCurrent(current - 1);
    }
    const newList = [];
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i] !== photoIndex) {
        newList.push(slides[i]);
      }
    }
    setSlides(newList);

    await api.delete(`/pictures/${photoIndex.id}`, {
      headers: authHeader(),
    });

    if (newList.length === 0) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }

  return (
    <RootStyled>
      {user.user_type !== 'client' && (
        <DeleteButtonStyled onClick={() => deletePhoto(slides[current])}>
          <MdDelete />
          Remover foto
        </DeleteButtonStyled>
      )}

      <Typography
        variant="subtitle1"
        style={{
          padding: '4px 8px',
          marginTop: '12px',
        }}
      >
        {current < slides.length ? current + 1 : current - 1}/{slides.length}
      </Typography>

      <SectionStyled>
        <IconButton onClick={() => previousSlide()} size="large">
          <MdOutlineKeyboardArrowLeft />
        </IconButton>
        {!slides.length ? (
          <div
            style={{
              width: '90vw',
              height: '90vh',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'green',
            }}
          >
            <MdPhoto size={200} color="#ccc" />
            <Typography>Nenhuma visualização de foto disponível</Typography>
          </div>
        ) : (
          slides.map((slide, slideIndex) => (
            <>
              {slideIndex === current && (
                <MainImageStyled
                  src={`${protocol}://${subdomain}.${baseURL}${slide.path.url}`}
                  alt={slide.name}
                />
              )}
            </>
          ))
        )}
        <IconButton onClick={() => nextSlide()} size="large">
          <MdOutlineKeyboardArrowRight />
        </IconButton>
      </SectionStyled>
      <MobileSectionStyled>
        {slides.map((slide, slideIndex) => (
          <>
            {slideIndex === current && (
              <MainImageStyled
                src={`${protocol}://${subdomain}.${baseURL}${slide.path.url}`}
                alt={slide.name}
              />
            )}
          </>
        ))}
        <div className="buttonContainer">
          <IconButton onClick={() => previousSlide()} size="large">
            <MdOutlineKeyboardArrowLeft />
          </IconButton>
          <IconButton onClick={() => nextSlide()} size="large">
            <MdOutlineKeyboardArrowRight />
          </IconButton>
        </div>
      </MobileSectionStyled>

      <ThumbStyled>
        {slides.map((slide, slideIndex) => (
          <img
            src={`${protocol}://${subdomain}.${baseURL}${slide.path.thumbnails.small}`}
            alt={slide.name}
            className={slideIndex === current ? 'active' : ''}
            onClick={() => setCurrent(index)}
          />
        ))}
      </ThumbStyled>
    </RootStyled>
  );
}

ImageSlider.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      folder_id: PropTypes.number,
      name: PropTypes.string,
    })
  ).isRequired,
  setSlides: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
